import { useEffect, useMemo, useState } from "react";

import { useDispatch } from "react-redux";
import {
  setChatGptData,
  setGenerateScriptModal,
  setSelectedSlideData,
} from "../../../../store/script/scriptSlice";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";
import { handleRegenerateSingleSlide } from "../../../../thunks/editor/scriptThunks";
import Loader from "../../Loader";

import { setSlides } from "../../../../store/slides/slidesSlice";
import { INITIAL_SLIDE_STATE } from "../../../../constants/states";
import { closePopover } from "../../../../store/common/uiSlice";
import { showToast } from "../../../../utils/general";
import VoiceCard from "../../VoiceCard";
import VoiceOptions, { audioVoiceTypes, subSidebar } from "./VoiceOptions";
import { Tooltip } from "../../Tooltip";
import { LANGUAGE_VOICES } from "../../../../constants/scriptConfig";

const GenerateScript = () => {
  const [voiceSelectorVisible, setVoiceSelectorVisible] = useState(false);

  const dispatch = useDispatch();
  const { chatGptData, selectedSlideData } = useSelector(
    (state) => state.script
  );
  const appState = useSelector((state) => state.appState);

  const { slides } = useSelector((state) => state.slides);
  useEffect(() => {
    if (!!chatGptData) {
      const firstSlide = chatGptData?.[0] || {};
      dispatch(
        setSelectedSlideData({
          ...firstSlide,
          currentSelectedSlide: 0,
        })
      );
    }
  }, [chatGptData]);

  const voiceIsNotExists = useMemo(
    () => !chatGptData?.every((data) => data.voiceFile?.mp3),
    [chatGptData]
  );

  const useScripts = async () => {
    const allUpdatedSlides = [...slides];
    await Promise.all(
      chatGptData.map(async (item, index) => {
        const existingSlide = { ...(slides[index] || {}) };
        allUpdatedSlides[index] = {
          ...INITIAL_SLIDE_STATE,
          label: `${index + 1}`,
          ...existingSlide,
          originalScript: item.originalScript,
          script: item.content,
          voiceFile: item?.voiceFile,
          generatedVoice: item?.voiceFile,
          is_user_audio: false,
          voice: item.voice,
          elevenlabs_voice: item.elevenLabVoice,
        };
      })
    );
    dispatch(setSlides(allUpdatedSlides));
    showToast("Scripts added successfully");

    dispatch(closePopover());
  };
  const { audioSubTab } = useSelector((state) => state.ui);

  const isElevenLabsTabSelected = useMemo(
    () => subSidebar[audioSubTab]?.name === audioVoiceTypes.NEW,
    [audioSubTab]
  );
  const { elevenLabsVoices } = useSelector((state) => state.script);

  const onVoiceChange = (val, language, gender) => {
    dispatch(
      setChatGptData(
        chatGptData.map((item, index) => {
          let voice = item.voice;
          let elevenLabVoice = item.elevenLabVoice;
          if (index === selectedSlideData.currentSelectedSlide) {
            voice = val;

            if (isElevenLabsTabSelected) {
              const find = elevenLabsVoices.find((v) => v.id === val);
              const selectedLanguage =
                LANGUAGE_VOICES.find(
                  (v) =>
                    v.id.includes(language) &&
                    v.gender.toLowerCase() === (gender || "male").toLowerCase()
                ) || LANGUAGE_VOICES[0];

              if (find) {
                elevenLabVoice = {
                  ...find,
                  language: selectedLanguage.language,
                  languageId: selectedLanguage.id,
                };
              }
            } else {
              elevenLabVoice = undefined;
            }
          }
          return {
            ...item,
            voiceFile: null,
            voice,
            elevenLabVoice,
          };
        })
      )
    );
  };

  return voiceSelectorVisible ? (
    <div className="px-2 w-full h-full">
      <VoiceOptions
        useAi
        doNoUpdateVoice
        onVoiceChange={onVoiceChange}
        onClose={() => setVoiceSelectorVisible(false)}
      />
    </div>
  ) : (
    <div className="bg-gray w-full overflow-auto">
      {appState === "imageLoading" && (
        <div className="flex flex-grow h-4/5 justify-center text-sm text-gray-500 items-center text-center w-full">
          <Loader />
        </div>
      )}
      <div className="flex h-10 gap-1 items-center p-2 bg-gradient-to-b from-gray-300 to-gray-100 to-90%">
        <FontAwesomeIcon
          icon={faArrowLeft}
          onClick={() => dispatch(setGenerateScriptModal(false))}
          className="mr-2 p-1 h-4 border-gray-500 border rounded-lg cursor-pointer"
        />
        <span
          className="text-gray-500 cursor-pointer"
          onClick={() => dispatch(setGenerateScriptModal(false))}
        >
          {" "}
          BACK{" "}
        </span>
        <span className="text-md">ChatGpt Generated Script</span>
        {/* <button onClick={() => dispatch(handleRegenerateSingleSlide())}>
          Regenerate Slide
        </button> */}
      </div>
      <div className="max-h-[calc(100%_-_100px)] h-full overflow-auto">
        <div style={{ padding: "14px 11px 18px 23px" }}>
          <div className="flex justify-between">
            <div
              style={{
                border: "1px solid rgba(0, 0, 0, 0.20)",
                borderRadius: "8px",
                maxHeight: "250px",
                overflowY: "auto",
                flexBasis: "20%",
              }}
            >
              {chatGptData &&
                !!chatGptData.length &&
                chatGptData.map((item, index) => (
                  <div
                    key={`selected-${index}`}
                    style={{
                      fontWeight: 500,
                      lineHeight: "20px",
                      fontSize: "14px",
                      height: "40px",
                      cursor: "pointer",
                      padding: "10px 0px 10px 15px",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.20)",
                    }}
                    onClick={() => {
                      dispatch(
                        setSelectedSlideData({
                          ...item,
                          currentSelectedSlide: index,
                          bulletpoints: item.bulletpoints,
                          content: item.content,
                          title: item.title,
                        })
                      );
                    }}
                  >
                    {`Slide ${index + 1}`}
                  </div>
                ))}
            </div>
            <div
              style={{
                flexBasis: "75%",
                maxHeight: "250px",
                overflowY: "auto",
              }}
            >
              <div>
                {/* <span> {selectedSlideData.title}</span> */}
                <div> {selectedSlideData.originalScript}</div>
                {/* <div
                style={{
                  marginTop: "15px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <span>Key Points</span>
                {selectedSlideData.bulletpoints &&
                  selectedSlideData.bulletpoints.length >= 1 && (
                    <ul>
                      {selectedSlideData.bulletpoints.map((item, index) => (
                        <li key={`selected-data-${index}`}>{item}</li>
                      ))}
                    </ul>
                  )}
              </div> */}
              </div>
            </div>
          </div>
        </div>
        <VoiceCard
          key="use-ai-card"
          isUseAi
          setVoiceSelectorVisible={setVoiceSelectorVisible}
        />
      </div>
      <div className="flex justify-end items-center absolute bg-gray-50 w-full p-2 bottom-0 right-0">
        <button
          disabled={voiceIsNotExists}
          onClick={useScripts}
          className={`${
            voiceIsNotExists
              ? "bg-gray-500 cursor-not-allowed"
              : "bg-black hover:bg-blue-600"
          } relative text-white font-bold py-1 px-2 rounded inline-flex items-center group overflow-visible`}
        >
          Use Scripts
          {voiceIsNotExists && <Tooltip>Please generate the voice.!</Tooltip>}
        </button>
      </div>
    </div>
  );
};

export default GenerateScript;
